import { css } from 'styled-components';

const variables = ({ mode }) => css`
  :root {
    --dark-navy: ${mode === 'light' ? '#495670' : '#020c1b'};
    --navy: ${mode === 'light' ? '#ccd6f6' : '#0a192f'};
    --light-navy: ${mode === 'light' ? '#a8b2d1' : '#112240'};
    --lightest-navy: ${mode === 'light' ? '#8892b0' : '#233554'};
    --navy-shadow: ${mode === 'light' ? 'none' : `rgba(2, 12, 27, 0.7)`};

    --slate: ${mode === 'light' ? '#0a192f' : '#8892b0'};
    --light-slate: ${mode === 'light' ? '#112240' : '#a8b2d1'};
    --lightest-slate: ${mode === 'light' ? '#233554' : '#ccd6f6'};

    --white: ${mode === 'light' ? '#0a192f' : '#e6f1ff'};
    --green: ${mode === 'light' ? '#cb4154' : '#64ffda'};

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
